// extracted by mini-css-extract-plugin
export var darkBackground = "section-module--darkBackground--7594a";
export var noMargin = "section-module--noMargin--6042a";
export var section = "section-module--section--78d1f";